import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL

export const createCustomFieldApi = async payload => {
  try {
    console.log(payload)
    let apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }
    const response = await axios.post(
      `${apiBaseUrl}/add-custom-field`,
      payload,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}

export const getLeadsCustomFieldApi = async () => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }
    const response = await axios.get(`${apiBaseUrl}/view-leads-custom-fields`, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}

export const updateCustomFieldApi = async payload => {
  try {
    console.log(payload)
    let apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }
    const response = await axios.post(
      `${apiBaseUrl}/update-custom-field`,
      payload,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}

export const getCustomerCustomFieldApi = async () => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }
    const response = await axios.get(
      `${apiBaseUrl}/view-customers-custom-fields`,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}
